import Main from "./works/main";
const main = new Main();
